import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/close_bai.png'


const _hoisted_1 = { class: "pop_container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "btn_container" }

import { ref } from 'vue'
import MainButton from '../../components/common/mainButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'rulePopup',
  setup(__props, { expose: __expose }) {

const show = ref(false)
const content = ref([])
const open = (data: any) => {
    show.value = true
    content.value = data
}
const close = () => {
    show.value = false
}
__expose({
    open,
})


return (_ctx: any,_cache: any) => {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    style: {
        minWidth: '100%',
        background: 'transparent',
        borderRadius: '10px',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
    }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "close_icon" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "",
            onClick: close
          })
        ]),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("common.activityTitle")), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.value, (item) => {
            return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(MainButton, {
            title: _ctx.$t('common.ok'),
            onclick: close,
            activeStatus: true
          }, null, 8, ["title"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})